// 调用 BusinessHandleW 方法
export const handleYB_Business_Upload = async (params) => {
    try {
        const response = await fetch('http://localhost:9999/business', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params)
        });

        const result = await response.json();

        if (result.success) {
            return {
                success: true,
                data: result.data
            };
        } else {
            return {
                success: false,
                error: result.error
            };
        }
    } catch (error) {
        console.error('调用BusinessHandleW失败:', error);
        return {
            success: false,
            error: '网络请求失败: ' + error.message
        };
    }
};

// 调用 Init 方法
export const handleYB_1101_Upload = async (params) => {
    try {
        const response = await fetch('http://localhost:9999/init', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params)
        });

        const result = await response.json();

        if (result.success) {
            return {
                success: true,
                data: result.data
            };
        } else {
            return {
                success: false,
                error: result.error
            };
        }
    } catch (error) {
        console.error('调用Init失败:', error);
        return {
            success: false,
            error: '网络请求失败: ' + error.message
        };
    }
};